<div class="modal-header" i18n="@@GeneralTermsAndConditions">
  AGB
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>    
<div class="modal-body">

</div>
<div class="modal-footer">
</div>
